import _toConsumableArray from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/inherits.js";
var _excluded = ["enum"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import MaskedPattern from './pattern.js';
import IMask from '../core/holder.js';
import ChangeDetails from '../core/change-details.js';
import { DIRECTION } from '../core/utils.js';
import ContinuousTailDetails from '../core/continuous-tail-details.js';
import './base.js';
import './factory.js';
import './pattern/chunk-tail-details.js';
import './pattern/cursor.js';
import './pattern/fixed-definition.js';
import './pattern/input-definition.js';
import './regexp.js';

/** Pattern which validates enum values */
var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
  _inherits(MaskedEnum, _MaskedPattern);
  function MaskedEnum(opts) {
    _classCallCheck(this, MaskedEnum);
    return _callSuper(this, MaskedEnum, [_objectSpread(_objectSpread({}, MaskedEnum.DEFAULTS), opts)]); // mask will be created in _update
  }
  _createClass(MaskedEnum, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedEnum.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var enum_ = opts.enum,
        eopts = _objectWithoutProperties(opts, _excluded);
      if (enum_) {
        var lengths = enum_.map(function (e) {
          return e.length;
        });
        var requiredLength = Math.min.apply(Math, _toConsumableArray(lengths));
        var optionalLength = Math.max.apply(Math, _toConsumableArray(lengths)) - requiredLength;
        eopts.mask = '*'.repeat(requiredLength);
        if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
        this.enum = enum_;
      }
      _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, eopts);
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      var _this = this;
      if (flags === void 0) {
        flags = {};
      }
      var matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
      var matches = this.enum.filter(function (e) {
        return _this.matchValue(e, _this.unmaskedValue + ch, matchFrom);
      });
      if (matches.length) {
        if (matches.length === 1) {
          this._forEachBlocksInRange(0, this.value.length, function (b, bi) {
            var mch = matches[0][bi];
            if (bi >= _this.value.length || mch === b.value) return;
            b.reset();
            b._appendChar(mch, flags);
          });
        }
        var d = _get(_getPrototypeOf(MaskedEnum.prototype), "_appendCharRaw", this).call(this, matches[0][this.value.length], flags);
        if (matches.length === 1) {
          matches[0].slice(this.unmaskedValue.length).split('').forEach(function (mch) {
            return d.aggregate(_get(_getPrototypeOf(MaskedEnum.prototype), "_appendCharRaw", _this).call(_this, mch));
          });
        }
        return d;
      }
      return new ChangeDetails({
        skip: !this.isComplete
      });
    }
  }, {
    key: "extractTail",
    value: function extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      // just drop tail
      return new ContinuousTailDetails('', fromPos);
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      var _this2 = this;
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      if (fromPos === toPos) return new ChangeDetails();
      var matchFrom = Math.min(_get(_getPrototypeOf(MaskedEnum.prototype), "nearestInputPos", this).call(this, 0, DIRECTION.FORCE_RIGHT), this.value.length);
      var pos;
      for (pos = fromPos; pos >= 0; --pos) {
        var matches = this.enum.filter(function (e) {
          return _this2.matchValue(e, _this2.value.slice(matchFrom, pos), matchFrom);
        });
        if (matches.length > 1) break;
      }
      var details = _get(_getPrototypeOf(MaskedEnum.prototype), "remove", this).call(this, pos, toPos);
      details.tailShift += pos - fromPos;
      return details;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.enum.indexOf(this.value) >= 0;
    }
  }]);
  return MaskedEnum;
}(MaskedPattern);
/** Match enum value */
MaskedEnum.DEFAULTS = _objectSpread(_objectSpread({}, MaskedPattern.DEFAULTS), {}, {
  matchValue: function matchValue(estr, istr, matchFrom) {
    return estr.indexOf(istr, matchFrom) === matchFrom;
  }
});
IMask.MaskedEnum = MaskedEnum;
export { MaskedEnum as default };